module.exports = __webpack_public_path__ + "static/media/Banner_new.68adcea0.png";